import { lastValueFrom } from 'rxjs';

import {
  getUserNotebook, getUserNotebookSuccess,
  updateUserNotebook, updateUserNotebookSuccess
} from '../slices/notebook.slice';

import { addApiErrorToast } from '../slices/toast.slice';
import { AppListenerEntry } from '@/redux';

export const epicGetUserNotebook: AppListenerEntry = {
  actionCreator: getUserNotebook,
  effect: async ({ payload }: ReturnType<typeof getUserNotebook>, { dispatch, extra: { notebookService } }) => {
    try {
      const notebook = await lastValueFrom(notebookService.getUserNotebook(payload.pickId));
      dispatch(getUserNotebookSuccess({ notebook }));
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};

export const epicUpdateUserNotebook: AppListenerEntry = {
  actionCreator: updateUserNotebook,
  effect: async ({ payload }: ReturnType<typeof updateUserNotebook>, { dispatch, extra: { notebookService } }) => {
    try {
      const notebook = await lastValueFrom(notebookService.updateUserNotebook(payload.content)) as any;
      dispatch(updateUserNotebookSuccess({ notebook }));
      dispatch(getUserNotebook({ pickId: notebook?.refPick }));
    } catch (error) {
      dispatch(addApiErrorToast({ error }));
    }
  }
};
